import { render } from "./productivityApp.vue?vue&type=template&id=11f27969&scoped=true"
import script from "./productivityApp.vue?vue&type=script&lang=js"
export * from "./productivityApp.vue?vue&type=script&lang=js"

import "./productivityApp.vue?vue&type=style&index=0&id=11f27969&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11f27969"]])

export default __exports__